/**
 * Browser translation (Chrome/Google Translate) and some extensions replace
 * text nodes React still references. React's next commit then calls
 * removeChild/insertBefore against a node that's no longer a child, throws
 * NotFoundError, and unmounts the whole app (facebook/react#11538).
 * Skip those stale operations instead of crashing the page.
 */
export function installDomMutationGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn("Skipped removeChild on a node moved by an external DOM mutation", child, this);
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn("Skipped insertBefore against a node moved by an external DOM mutation", referenceNode, this);
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
